// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2_Tqt","title":"AfterBackImages_title__1Tkko","images":"AfterBackImages_images__3YQtz"};